import {
  IFieldValidation,
  IValidateFn,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { BokforderType } from '../Queries/_QueryTypes/BokforderType';

const useValidateKontering = (): IValidateFn<BokforderType> => {
  return ({ currentValues, touched }) => {
    const errors: IFieldValidation[] = [];

    //Validera rubrik
    if (currentValues.TEXT == null || currentValues.TEXT.trim() == '') {
      const rubrikError: IFieldValidation = {
        fieldName: 'TEXT',
        type: 'RequiredValueHint',
        showAsHint: !touched.TEXT,
      };

      errors.push(rubrikError);
    }

    return errors;
  };
};

export default useValidateKontering;
